import {
  HttpGetRequest,
  HttpPostRequest,
  HttpPutRequest,
} from "./HttpRequest.js";


/**
 *
 * @param {*} payload
 * @returns
 */
export async function create(payload) {
  let url = "/surgical_intervention";
  return await HttpPostRequest(url, payload).then((response) => {
    return response.json();
  });
}

/**
 *
 * @param {*} id
 * @param {*} payload
 * @returns
 */
export async function update(id, payload) {
  let url = "/surgical_intervention/" + id;
  return await HttpPutRequest(url, payload).then((response) => {
    return response.json();
  });
}

/**
 *
 * @param {*} id
 * @returns
 */
export async function getOne(id) {
  let url = "/surgical_intervention/" + id;
  return await HttpGetRequest(url).then((response) => {
    return response.json();
  });
}

/**
 *
 * @param {*} payload
 * @returns
 */
export async function all(payload) {
  let url = "/surgical_interventions";
  return await HttpPostRequest(url, payload).then((response) => {
    return response.json();
  });
}

/**
 *
 * @param {*} id
 * @returns
 */
export async function getRealSiips(id) {
  let url = "/surgical_intervention/" + id + "/real_siips";
  return await HttpGetRequest(url).then((response) => {
    return response.json();
  });
}

/**
 *
 * @param {*} id
 * @param {*} payload
 * @returns
 */

export async function cancel(id, payload) {
  let url = "/surgical_intervention/" + id + "/cancel";;
  return await HttpPostRequest(url, payload).then((response) => {
    return response.json();
  });
}

/**
 *
 * @param {*} id
 * @param {*} reason_id
 * @param {*} start_at
 * @param {*} expected_end_at
 * @returns
 */
export async function reschedule(id, reason_id, start_at, expected_end_at) {
  let url = "/surgical_intervention/" + id + "/reschedule";
  return await HttpPutRequest(url, {
    reason_id: reason_id,
    start_at: start_at,
    expected_end_at: expected_end_at,
  }).then((response) => {
    return response.json();
  });
}

/**
 *
 * @param {*} id
 * @param {*} reason_id
 * @param {*} start_at
 * @param {*} expected_end_at
 * @returns
 */
export async function updateOutputType(id, type) {
  let url = "/surgical_intervention/" + id + "/output_type";
  return await HttpPutRequest(url, {
    output_type: type,
  }).then((response) => {
    return response.json();
  });
}